

const v4 = resolve => require(['./v4.vue'], resolve);

export default {
  v4
}
